package com.kitco.metalynxscrapit.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class AdjustmentType {
    Points, Percent
}
